import { Pipe, PipeTransform } from '@angular/core';
import { ROUTE_OVERRIDE } from '@df/core/meta/meta-state';

@Pipe({
    name: 'routeOverride',
    standalone: true
})
export class RouteOverridePipe implements PipeTransform {
    transform(input?: string) {
        return input ? routeOverride(input) : input;
    }
}

export function routeOverride(input: string): string {
    if (typeof input !== 'string') {
        return input;
    }
    if (ROUTE_OVERRIDE[input]) {
        return ROUTE_OVERRIDE[input];
    }
    const parts = input.split('/');
    const index = parts[0] ? 0 : 1;
    if (ROUTE_OVERRIDE[parts[index]]) {
        parts[index] = ROUTE_OVERRIDE[parts[index]];
    }

    return parts.join('/');
}
